import type { LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import { Link as ChakraLink } from '@chakra-ui/react';

const ExternalLink = ({ children, ...rest }: ChakraLinkProps) => {
  return (
    <ChakraLink role='link' target='_blank' rel='noreferrer noopener' {...rest}>
      {children}
    </ChakraLink>
  );
};

export default ExternalLink;
